import CloseIcon from '@mui/icons-material/Close';
import { Box, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { memo, useEffect,useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { IState } from "../../../redux/reducers/rootReducers";
import { getContactsTickets, handleContactTicketsModal } from '../../../redux/actions/TicketsManagement/TicketsManagement';
import InfiniteScroll from 'react-infinite-scroll-component';
import { debounce } from 'lodash';
import { ConvertZ } from '../../helpers/helperFunctions';
import { getTicketStatus } from '../../../redux/actions/SystemManagement/TicketStatus';
import { getGroup } from '../../../redux/actions/userManagement/group';
import { useNavigate } from 'react-router-dom';
import { NoDataImg } from '../../common/svgIcons/chartIcon';
import { VariableSizeList } from "react-window";
const isHtml = (text = "") => /<\/?[a-z][\s\S]*>/i.test(text);

// converting to plaintext
const htmlToPlainText = (html = "") => {
  if (!html) return "-";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const ContactTicketsViewPopup = (props:any) => {
    const {allResponses={},contactsInfo={},dispatch} = props;

    
    useEffect(()=>{
        if(!allResponses.groups || !allResponses.ticketStatus){
            dispatch(getTicketStatus());
            dispatch(getGroup());
        }
    },[])
   
    return(<>
        {(allResponses?.ticketStatus && allResponses?.groups && contactsInfo?.id)&&
            <ContactTicketsViewPopup1 {...props}/>
        }
    </>)
};
const ContactTicketsViewPopup1 = memo(({allResponses={},contactsInfo={},dispatch}:any) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [ids] = useState({
        groupIds : allResponses.groups.map((i:{id:number})=>i.id),
        statusIds : allResponses.ticketStatus.map((i:{id:number})=>i.id),
    })
    const [ticketsList,setTicketsList] = useState<any>([]);
    const [hasMore, setHasMore] = useState(true);
    const [pageNum, setPageNum] = useState(0);
    const [ticketIndex, setTicketIndex] = useState(0);
    const [loader,setLoader]= useState(false)
    const listRef = useRef<any>(null);
    const [scrollOffset, setScrollOffset] = useState(0);
    const onCloseHandler = () => {
        dispatch(handleContactTicketsModal(null))
        setTicketsList([])
        setHasMore(true)
        setPageNum(0)
        setTicketIndex(0)
    }
    useEffect(()=>{
//         console.log("ContactTicketsViewPopup",allResponses?.ticketStatus, allResponses?.groups, contactsInfo)
    },[allResponses,contactsInfo])
    useEffect(()=>{
        // if(!contactsInfo?.id) {
        //     onCloseHandler();
        //     return;
        // }
        fetchNextWeek()
    },[contactsInfo?.id])
    const getContactsTicketsCB = (data:any)=>{
        setLoader(true)
//         console.log("getContactsTicketsCB",data);
        // setTicketsList((old:any)=>old.concat(data))
        setTicketsList((prev: any[]) => {
        const newList = [...prev, ...data];
        setTimeout(() => {
            if (listRef.current) {
            listRef.current.scrollTo(scrollOffset);
            }
        }, 0);
        return newList;
        });
        setHasMore(data.length === 100);
        setPageNum((p) => p + 1);
        // setHasMore(data.length === 100 ? true : false)
        // setPageNum(pageNum+1)
        setLoader(false)
    }
    const fetchNextWeek = debounce(() => {
        setLoader(true)
        const { groupIds=[], statusIds=[] } = ids;
        const endDateVal = new Date();
      const currentTime = new Date(`${endDateVal.getFullYear() - 3}`);
      currentTime.setHours(0,0,0,0);
      endDateVal.setHours(23,59,59,59);
      const payload = {
            "startDate": currentTime,
            "endDate": endDateVal,
            "search": "",
            "contactIds": [contactsInfo?.id],
            "agentIds": [],
            "groupIds" : [0,...groupIds],
            "ticketTypeIds": [],
            "priorityIds": [],
            "statusIds" : [0,...statusIds],
            "sortPropString": "OpenDateTime",
            "ticketFilterPropString": "OpenDateTime",
            "sortTypeString": "Desc",
            "page": pageNum,
            "count": 10000
        }
        
        dispatch(getContactsTickets(payload,getContactsTicketsCB))
    },100);
{loader && <>Loading </>}

    return (<>
   
        {contactsInfo?.id &&
            <Box className={`${classes.popupHolder}  ${classes.textWithSpanTitle}`} >
                <Box className="modal-dialog">
                    
                     {loader ? (
                        <Box className="modal-content">
                          <Box display="flex" justifyContent="center" alignItems="center" height={380}>
            <CircularProgress size={45} />
        </Box>
                    </Box>
      
    ) : (
                    <Box className="modal-content">
                        <Box className="modal-header">
                            <Typography>{contactsInfo?.name}'s Tickets </Typography>
                            
                            <Typography className="cursor-pointer" onClick={onCloseHandler}>
                                <CloseIcon className="cursor-pointer" />
                            </Typography>
                        </Box>
                        <Box className="modal-body">
                            <Box component="section">
                                <Grid container>
                                    {ticketsList.length ===0 &&
                                        <Grid item md={12} className='tetx-center pt-5 pb-5'>
                                            <NoDataImg />
                                        </Grid>
                                    }
                                    <Grid item md={5}> 
                                        {ticketsList.length>0 && (
                                            <InfiniteScroll
                                                dataLength={ticketsList.length || 0}
                                                next={fetchNextWeek}
                                                height={380}
                                                hasMore={hasMore}
                                                endMessage={<></>}
                                                loader={<></>}
                                            >
                                                <Box className="contacts-ticket-list">
                                                    {ticketsList?.map && ticketsList?.map((item: any, index: number) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <Typography onClick={()=>{setTicketIndex(index)}} className={`${ticketIndex === index ? "active" : ""} p-10p`}> {index+1}{")"}  {"#"}{item?.id}{"-"} {item?.ticketLogs?.title}</Typography>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </Box>
                                            </InfiniteScroll>
                                        )}
                                    </Grid>
                                  
                                    <Grid item md={7}>
                                        <Box className='p-10p'>
                                            {ticketsList?.[ticketIndex] && <>
                                                <Typography variant='h5' className="ellipses-4l">
                                                    {"#"} <span onClick={()=>{navigate(`/ticketInfoView/${ticketsList?.[ticketIndex]?.id}`)}} className='text-primary pointer'>{ticketsList?.[ticketIndex]?.id}</span> {"-"} {ticketsList?.[ticketIndex]?.ticketLogs?.title}
                                                </Typography>
                                                <Divider/>
                                                <Box className="ticket-info-popup">
                                                    <Box>
                                                        <Typography className="label text-primary">Description</Typography>
                                                        {/* <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.description || "-"}</Typography> */}
                                                        <Typography> {isHtml(ticketsList?.[ticketIndex]?.ticketLogs?.description) ? htmlToPlainText(ticketsList?.[ticketIndex]?.ticketLogs?.description)
                                                            : ticketsList?.[ticketIndex]?.ticketLogs?.description} </Typography>
                                                    </Box>
                                                    <Divider/>
                                                    <Box>
                                                        <Grid container spacing={2}>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Group</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.group?.name || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Agent</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.agent?.firstName || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Ticket Type</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.ticketType?.name || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Priority</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.priority?.name || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Status</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.ticketLogs?.ticketStatus?.displayName || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Source</Typography>
                                                                <Typography>{ticketsList?.[ticketIndex]?.sourceCode || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Created Date</Typography>
                                                                <Typography>{ConvertZ(ticketsList?.[ticketIndex]?.createdDateTime) || "-"}</Typography>
                                                            </Grid>
                                                            <Grid item md={6}>
                                                                <Typography className="label text-primary">Due Date</Typography>
                                                                <Typography>
                                                                    {
                                                                        ticketsList?.[ticketIndex]?.ticketLogs?.dueDateTime
                                                                        ?
                                                                        ConvertZ(ticketsList?.[ticketIndex]?.ticketLogs?.dueDateTime)
                                                                        : 
                                                                        "-"
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </>}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
    )}
                </Box>
            </Box>
        }
    </>)
})
const mapStateToProps = (state:IState) => {
  return ({
    allResponses : state?.TicketsReducer?.allResponses,
    contactsInfo : state?.TicketViewReducer?.contactTicketInfo
  })
};

export default connect(mapStateToProps)(ContactTicketsViewPopup);

const useStyles = makeStyles(() =>
    createStyles({
        flxWrap: {
            flexWrap: "wrap",
        },
        tagTxt: {
            background: "#ddd",
            marginRight: "5px",
            width: "max-content",
            maxWidth: "100%",
            padding: "0px 6px",
            fontSize: "12px !important",
        },
        title: {
            flexGrow: 1,
        },
        primaryTxt: {
            color: "#000"//data.mode === "light" ? '#1261b4' : mode.text,
        },
        successTxt: {
            color: '#00b315'
        },
        dangerTxt: {
            color: 'red'
        },
        TicketTag: {
            "&::after": {
              background: "#fff"//mode.cardHeader,
            },
            "&::before": {
              background: "fff"//mode.cardHeader,
            },
            "&.whitebck": {
              "&::after": {
                background: `#fff`,
              },
              "&::before": {
                background: `#fff`,
              }
            }
        },
        ticketCardTags: {
            display: 'block',
            fontSize: '9px',
            padding: '5px 8px',
            background: "#ddd",//mode.solids,
            whiteSpace: 'nowrap',
            margin: '0 4px',
            color:"#000" //mode.text
        },
        tagBlue: {
            background: '#1261b4 !important',
            color: '#ffffff !important',
        },
        tagWarn: {
            background: '#f39732 !important',
            color: '#ffffff !important',
        },
        viewDtls : {
            background: "#f1f1f1",
            margin: 0,
            marginLeft: "5px !important",
            padding: "3px 10px",
            lineHeight: 1,
            borderRadius: "15px",
            "& a":{
              display: "flex !important",
              alignItems: "center",
              gap: "5px",
              color:"#000",
            },
            "& span":{
              fontSize: "10px",
              display: "block",
            }
        },
        row: {
            display: "flex"
        },
        alignItemsCenter:{
            alignItems: "center",
        },
        popupHolder: {
            position: "fixed",
            top: 0,
            left: 0,
            background: "#0005",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            zIndex: 1399,
            "& .modal-dialog": {
                display: "flex",
                height: '100%',
                justifyContent: "center",
                alignItems: "center",
            },
            "& .modal-header": {
                display: "flex",
                alignItems: "center",
                padding: "20px",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                paddingBottom: "10px"
            },
            "& .modal-body": {
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
                padding: "0px"
            },
            "& .modal-body > div": {
                margin: "0 !important",
                maxWidth: "calc(100% - 15px)"
            },
            "& .modal-content": {
                background: "#fff",
                width: "100%",
                maxWidth: "1000px",
                borderRadius: "5px",
                //padding: "20px",
                "& img.Contactprofile": {
                    width: "calc(100% - 10px)",
                },
                "& img": {
                    objectFit: "cover"
                }
            }
        },
        textWithSpanTitle: {
            fontSize:"12px",
            "& .title-txts": {
                lineHeight: '1.5',
                marginBottom: 10,
                fontSize: '13px',
                "& > span": {
                    display: 'block',
                    fontSize: '11px',
                    marginBottom: '2px',
                    lineHeight: '1',
                    color: "#5559"//mode.link,
                }
            }
        },
        txtWithLink: {
            fontSize: ".7em",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            "& span": {
                wordBreak: "break-all"
            },
            "& a": {
                fontSize: ".7em",
                textDecoration: "none",
                display: "inline-block",
                lineHeight: 1,
                "& svg": {
                    fontSize: "12px"
                }
            }
        },
        viewPopupTitle: {
            fontSize: 15,
            maxWidth: "255px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          cardTcktCount: {
            padding: "5px 10px",
            background: "#ffa000",
            display: "inline",
            lineHeight: "1",
            fontSize: "12px",
            position: "relative",
            "& .dots": {
              position: "absolute",
              width: "8px",
              height: "8px",
              background: "#fff",//mode.cardHeader,
              left: "-5px",
              borderRadius: "50%",
              top: "50%",
              transform: "translateY(-50%)",
            },
            "& .dots.dots-right": {
              left: "unset",
              right: "-5px",
            },
            "& .dots.whiteBG": {
              background: "#fff" //mode.whiteSolid
            },
          },
    }))